export const ROLES = {
    MD: 'ROLE_MD',
    ADMIN: 'ROLE_ADMIN',
    SOP: 'ROLE_SOPDIR',
    IAM: 'ROLE_IAM',
};

export const POWER_ROLES = [ROLES.MD, ROLES.ADMIN, ROLES.SOP];
export const ALL_ROLES = [...POWER_ROLES, ROLES.IAM];